<dx-popup
  [(visible)]="visible"
  [showTitle]="true"
  title="Pièces non intégrées"
  [closeOnOutsideClick]="true"
  [showCloseButton]="true"
  [width]="1000"
  [height]="700"
>
  <div *dxTemplate="let data of 'content'">
    <div class="popup-piece-non-integrees-wrapper">
      <!-- Message d'alerte -->
      <div *ngIf="piecesNonIntegrees?.length > 0" class="alert-message">
        <div class="alert-content">
          <span class="dx-icon-warning alert-icon"></span>
          <div class="alert-text">
            <span class="alert-title">Attention !</span>
            <p *ngIf="piecesNonIntegrees.length > 1">
              {{ piecesNonIntegrees.length }} pièces n'ont pas été intégrées au back office.
            </p>
            <p *ngIf="piecesNonIntegrees.length == 1">
              La pièce n'a pas été intégrée au back office.
            </p>
            <p *ngIf="nbPiecesNonIntegreesInitial != piecesNonIntegrees.length">
              {{ nbPiecesNonIntegreesInitial - piecesNonIntegrees.length }} pièce(s) ont été intégrées avec succès.
            </p>
          </div>
        </div>
      </div>

      <!-- Bouton de relance -->
      <div *ngIf="!showTraitements" style="margin: 12px 0;">
        <dx-button
          text="Relancer l'intégration back office"
          icon="refresh"
          (onClick)="relancerIntegrationBO()"
          [disabled]="!exportEnable"
          stylingMode="contained"
          type="default"
        ></dx-button>
      </div>

      <!-- Liste des pièces non intégrées -->
      <dx-data-grid
        *ngIf="!showTraitements"
        [dataSource]="piecesNonIntegrees"
        [showBorders]="true"
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [hoverStateEnabled]="true"
        style="min-height: 300px;"
        height="auto"
        width="100%"
      >
        <!-- Options -->
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="Multiple"></dxo-sorting>
        <dxo-scrolling showScrollbar="always"></dxo-scrolling>
        <dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[25, 50, 100]"
          [showInfo]="true"
          [visible]="true"
        ></dxo-pager>

        <!-- Colonnes -->
        <dxi-column dataField="numeroPiece" caption="Numéro" [width]="170"></dxi-column>
        <dxi-column dataField="pieceNature" caption="Type" [width]="100"></dxi-column>
        <dxi-column dataField="dateCreation" caption="Date" dataType="date" format="dd/MM/yyyy HH:mm" [width]="150"></dxi-column>
        <dxi-column dataField="societeIntitule" caption="Societe"></dxi-column>
        <dxi-column dataField="siteIntitule" caption="Site"></dxi-column>
      </dx-data-grid>

      <!-- Grille des résultats des traitements (affichée uniquement pendant et après le traitement) -->
      <app-traitement-export-bo-datagrid
        [compact]="true"
        [visible]="showTraitements"
        [traitements]="traitements"
        titre="Résultat des exportations en cours"
        [manualRefreshEnabled]="refreshManuelTraitementEnabled"
        (refreshRequested)="handleRefreshTraitements($event)"
      ></app-traitement-export-bo-datagrid>
    </div>
  </div>
</dx-popup>
